import React, {CSSProperties} from "react"
import classNames from "classnames";
import styles from '../css/Text.module.css'
import Box from "./Box";
import {rem} from "../utils/CSSUtils";

export interface Props {
    title: string,
    subtitle?: string,
    color?: string,
    xs?: boolean,
    s?: boolean,
    shrink?: boolean,
    lg?: boolean,
    center?: boolean,
}

export default (props: Props) => {

    // Props
    const {s, xs, center = true, lg, color, title, subtitle, shrink} = props;

    const titleStyle: CSSProperties = color ? {color} : {};
    const subtitleStyle = titleStyle;

    if (title && subtitle) {
        titleStyle.marginBottom = rem(2);
    }

    return (
        <Box center={center} shrink={shrink}>
            <div>
                {
                    title &&
                    <h3 style={titleStyle}
                        className={classNames({
                            [styles.h3Lg]: lg,
                            [styles.h3s]: s,
                            [styles.h3Xs]: xs,
                        })}>{title}</h3>
                }

                {
                    subtitle &&
                    <h6 style={subtitleStyle}
                        className={classNames({
                            [styles.h6Lg]: lg,
                            [styles.h6s]: s,
                            [styles.h6Xs]: xs,
                        })}>{subtitle}</h6>
                }
            </div>
        </Box>
    )
}
